export const environment = {
  production: true,
  publicConfigUrl: '/api/public/configuration',
  localDevSsoRedirect: false,
  ssoLoginRedirectIntervalInHours: 24,

  sentryDisabledOnUrls: new RegExp('^(?!.*(?:rpqa20-gi.rampitplatform.com|rpqa20-postman.rampitplatform.com|localhost)).*$'),
  // sentry config
  sentry: {
    DSN: 'https://045e6e25066690aea3e2915ed6cac4c8@o4504165036457984.ingest.us.sentry.io/4509331323748352',
    // environment setting needs to be updated as per the environment this is deployed to
    environment: 'qa',
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  },
  sentryIgnoredErrors: ['auth/wrong-password', 'auth/invalid-email', 'auth/user-not-found'],
};
